module.exports = __webpack_public_path__ + "static/media/puzzle_reveal_and_toss.mp3";